<form [formGroup]="previousRequestForm" *ngIf="isInternal">
  <div class="row justify-content-around mx-1">
    <div>
      <mat-form-field appearance="outline" class="w-100" color="accent">
        <mat-label>Equipment ID:</mat-label>
        <input matInput type="text" formControlName="equipmentId" aria-label="Equipment ID" maxlength="25"
               ngTrimSpaces ngSpecialCharacter>
        <mat-error *ngIf="previousRequestForm.controls.equipmentId.invalid">
          Please enter a valid Equipment ID
        </mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" class="w-100" color="accent">
        <mat-label>Request Number:</mat-label>
        <input matInput type="text" formControlName="requestNumber" aria-label="Request Number" maxlength="25">
        <mat-error [control]="previousRequestForm.controls.requestNumber" ns-error></mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" class="w-100" color="accent">
        <mat-label>Waybill Serial:</mat-label>
        <input matInput type="text" formControlName="waybillSerial" aria-label="Waybill Serial" maxlength="25"
               ngTrimSpaces ngSpecialCharacter>
        <mat-error [control]="previousRequestForm.controls.waybillSerial" ns-error></mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="w-100" appearance="outline" color="accent">
        <mat-label>Status</mat-label>
        <mat-select aria-label="Select a Status" formControlName="status">
          <mat-option *ngFor="let status of statusAndRequest.status" [value]="status.abbreviation">{{ status.fullName }}</mat-option>
        </mat-select>
        <mat-error [control]="previousRequestForm.controls.status" ns-error></mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="w-100" appearance="outline" color="accent">
        <mat-label>Type</mat-label>
        <mat-select aria-label="Select a Status" formControlName="type">
          <mat-option *ngFor="let type of statusAndRequest.requestType" [value]="type.abbreviation">{{ type.fullName }}</mat-option>
        </mat-select>
        <mat-error [control]="previousRequestForm.controls.type" ns-error></mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" class="w-100" color="accent">
        <mat-label>City:</mat-label>
        <input matInput type="text" formControlName="city" aria-label="City" maxlength="25"
               ngTrimSpaces ngSpecialCharacter>
        <mat-error [control]="previousRequestForm.controls.city" ns-error></mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" class="w-100" color="accent">
        <mat-label ngRequired>Date From</mat-label>
        <input matInput [max]="today" formControlName="dateFrom" placeholder="Date From" [matDatepicker]="pickerFrom">
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
        <mat-error [control]="previousRequestForm.controls.dateFrom" ns-error></mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" class="w-100" color="accent">
        <mat-label ngRequired>Date To</mat-label>
        <input matInput [max]="today" formControlName="dateTo" placeholder="Date To" [matDatepicker]="pickerTo">
        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
        <mat-error [control]="previousRequestForm.controls.dateTo" ns-error></mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="row m-4 justify-content-center">
    <button type="button" mat-stroked-button color="warn" aria-label="Clear" class="ml-2 mr-3"
            [disabled]="!previousRequestForm.dirty" (click)="reset()">
      Clear
    </button>
    <button type="button" mat-flat-button aria-label="Submit" color="accent" class="ml-2 mr-3"
            [disabled]="previousRequestForm.invalid" (click)="submitForm()">
      Submit
    </button>
  </div>
</form>
